import { ARN } from '@aws-sdk/util-arn-parser';

export const getRegionsFromArnList = (
  arns: ARN[] | undefined,
): string[] | undefined => {
  if (!arns) return [];

  return Array.from(
    arns.reduce((prev: Set<string>, arn: ARN) => {
      prev.add(arn.region.toString());
      return prev;
    }, new Set<string>()),
  );
};

export const getEndpointInfoFromArnList = (
  arns: ARN[] | undefined,
): { arn: ARN | undefined; name: string | undefined } => {
  if (!arns) return { arn: undefined, name: undefined };

  const endpointArn = arns.find((arn) => arn.resource.startsWith('endpoint'));
  const name = endpointArn?.resource.split('/')[1];
  return { arn: endpointArn, name };
};
